module.exports = __webpack_public_path__ + "static/img-formacion-17c00a1eef441c3404f059fd448cd8d3.svg";